import React from "react";
import ActionPlanPageView from "../../../../../actionplans/components/ActionPlanPageView";
import { WorkplaceAssessmentComponentProps } from "../_components/WorkplaceAssessmentComponentProps";
import { ActionPlansPanelListing } from "./_components/ActionPlansPanelListing";


export function ActionPlansPanel(props:WorkplaceAssessmentComponentProps & {
    onPlanLoaded:(id:string, title:string) => void
}): JSX.Element {

    const [loaded, setLoaded] = React.useState(false);
    const [selectedPlanId, setSelectedPlanId] = React.useState('');

    React.useEffect(function(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get('actionPlanId');
        if(id)
            setSelectedPlanId(id);
        setLoaded(true)
    }, [window.location.search]);

    function handleClickActionPlan(actionPlanId:string)
    {
        window.history.replaceState(null, '', `/workplaceassessments/${props.activity.id}?tab=actionplans&actionPlanId=${actionPlanId}`);
        setSelectedPlanId(actionPlanId);
    }

    function handleClickBack()
    {
        window.history.replaceState(null, '', `/workplaceassessments/${props.activity.id}?tab=actionplans`);
        setSelectedPlanId('');
    }

    function handleTitleLoaded(title:string)
    {
        if(selectedPlanId)
        {
            props.onPlanLoaded(selectedPlanId, title);
        }
    }
    
    return (
        <>
            {loaded && selectedPlanId==='' &&
                <ActionPlansPanelListing {...props} onActionPlanSelected={handleClickActionPlan} />
            }

            {loaded && selectedPlanId !== '' &&
                <ActionPlanPageView actionPlanId={selectedPlanId} onBack={handleClickBack}
                    onTitleChanged={handleTitleLoaded} />
            }

        </>
    );
}